import { Check, Clock, AlertTriangle, X } from "lucide-react";
import { fmtDateTime } from "@/lib/constants";
import { cn } from "@/lib/utils";

const DOT = {
  done: "bg-emerald-500 text-white border-emerald-500",
  current: "bg-pink-500 text-white border-pink-500 animate-pulse",
  pending: "bg-background text-muted-foreground border-muted-foreground/40",
  blocked: "bg-red-500 text-white border-red-500",
  warning: "bg-amber-500 text-white border-amber-500",
};
const ICON = { done: Check, current: Clock, pending: Clock, blocked: X, warning: AlertTriangle };

export function RacTimeline({ steps }) {
  if (!steps?.length) return null;
  return (
    <div className="op-card p-4" data-testid="rac-timeline">
      <div className="data-label mb-3">Perjalanan Permintaan (RAC)</div>
      <ol className="relative flex flex-col gap-4 sm:flex-row sm:gap-0">
        {steps.map((s, i) => {
          const Icon = ICON[s.state] || Clock;
          const lineDone = s.state === "done" && steps[i + 1]?.state === "done";
          return (
            <li key={s.key} className="relative flex flex-1 items-start gap-3 sm:flex-col sm:items-center sm:text-center" data-testid={`rac-step-${s.key}`} data-state={s.state}>
              {i < steps.length - 1 && <span className={cn("absolute hidden sm:block top-3.5 left-1/2 h-0.5 w-full", lineDone ? "bg-emerald-500" : "bg-muted-foreground/20")} />}
              <span className={cn("relative z-10 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2", DOT[s.state])}><Icon className="h-3.5 w-3.5" /></span>
              <div className="min-w-0">
                <div className={cn("text-xs font-semibold", s.state === "pending" && "text-muted-foreground", s.state === "warning" && "text-amber-600", s.state === "blocked" && "text-red-600")}>{s.label}</div>
                <div className="font-mono text-[10px] text-muted-foreground">{s.at ? fmtDateTime(s.at) : s.state === "current" ? "sedang berlangsung" : "—"}</div>
                {s.who && <div className="truncate text-[10px] text-muted-foreground">{s.who}</div>}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}

export function ItemsWithApproval({ items, partial }) {
  if (!Array.isArray(items) || !items.length) return null;
  return (
    <div className="col-span-2 sm:col-span-3" data-testid="ticket-items">
      {partial && <div className="mb-2 rounded-md border border-amber-500/50 bg-amber-500/10 p-2 text-xs text-amber-800 dark:text-amber-200" data-testid="partial-approval-banner"><b>Approval parsial</b> oleh {partial.by} · {fmtDateTime(partial.at)}: {partial.changes?.join("; ")}</div>}
      <div className="data-label mb-1">Daftar Barang</div>
      <ul className="space-y-1 text-xs">
        {items.map((x, i) => {
          const st = x.item_status; const orig = x.original_qty != null && Number(x.original_qty) !== Number(x.qty);
          return (
            <li key={i} className={cn("flex flex-wrap items-center gap-2 rounded border px-2 py-1", st === "rejected" && "border-red-500/40 bg-red-500/5 text-muted-foreground line-through", st === "adjusted" && "border-amber-500/50 bg-amber-500/5")} data-testid={`ticket-item-${i}`} data-item-status={st || "approved"}>
              <span className="font-medium">{x.name}</span>
              <span className="font-mono">×{Number(x.qty) || 0} {x.unit || "pcs"}</span>
              {orig && <span className="rounded bg-amber-500/20 px-1 font-mono text-[10px] text-amber-700 no-underline dark:text-amber-300">diminta {Number(x.original_qty)}</span>}
              {x.price ? <span className="text-muted-foreground">@ Rp {Number(x.price).toLocaleString("id-ID")}</span> : null}
              {st === "rejected" && <span className="rounded bg-red-600 px-1.5 text-[10px] text-white no-underline">DITOLAK{x.approval_note ? ` · ${x.approval_note}` : ""}</span>}
              {st === "adjusted" && <span className="rounded bg-amber-600 px-1.5 text-[10px] text-white">DISESUAIKAN{x.approval_note ? ` · ${x.approval_note}` : ""}</span>}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
